import { NotificationItem } from './notification-item';

export class Notification {
  public constructor(
    /**
     * Notification No   Number that identifies the notification.
     */
    public notificationNumber: string,
    /**
     * Key that enables notifications to be differentiated and grouped according to notification category, notification origin and other criteria.   The features of the notification are defined in Customizing for each notification type.
     */
    public notificationType: string,
    /**
     * Notification Type Texts
     */
    public notificationTypeText: string,
    /**
     * Short Text   Short description of the contents of a notification.
     */
    public systemStatus: string,
    /**
     * Number which uniquely identifies an assembly.
     */
    public assembly: string,
    /**
     * Short Text   Short description of the contents of a notification.
     */
    public shortText: string,
    /**
     * Time, at Which Record Was Added
     */
    public createdTime: string,
    /**
     * Short Text   Short description of the contents of a notification.
     */
    public createdBy: string,
    /**
     * Object Number for Status Management   Number under which the maintenance notification is stored in the status management
     */
    public objectNumber: string,
    /**
     * Equipment Number   Number by which a piece of equipment can be clearly identified.
     */
    public equipmentNumber: string,
    /**
     * Maintenance Planning Plant   Key that identifies the maintenance planning plant.
     */
    public maintenancePlanningPlant: string,
    /**
     * Time of Notification   Time at which the notification was created.
     */
    public notificationTime: string,
    /**
     * Production Version   Key which determines the various production techniques according to which a material can be manufactured.   The production version determines the following:   the BOM alternative for a BOM explosion   the task list type, the task list group and the task list group counter for allocation to task lists   lot-size restrictions for repetitive manufacturing
     */
    public mouldStatus: string,
    /**
     * Name of Person Reporting Notification   Name of the person who reported the notification
     */
    public reportingPerson: string,
    /**
     * Functional Location   Label that uniquely identifies a functional location.   If alternative labels exist for a functional location, you can define in your user profile which label should be displayed in this field.
     */
    public mouldStatusText: string,
    /**
     * Order Number   Number which identifies an order within a client.
     */
    public orderNumber: string,
    /**
     * Production Version   Key which determines the various production techniques according to which a material can be manufactured.   The production version determines the following:   the BOM alternative for a BOM explosion   the task list type, the task list group and the task list group counter for allocation to task lists   lot-size restrictions for repetitive manufacturing
     */
    public elementStatus: string,
    /**
     * The key in this field indicates the importance of the processing of the order/notification.
     */
    public priority: string,
    /**
     * Functional Location   Label that uniquely identifies a functional location.   If alternative labels exist for a functional location, you can define in your user profile which label should be displayed in this field.
     */
    public elementStatusText: string,
    /**
     * Priority Text
     */
    public priorityText: string,
    /**
     * Catalog Type - Coding   Key for the catalog type that defines the coding.
     */
    public catalogType: string,
    /**
     * Code Group - Coding   Key for the code group that contains the codes for coding the notification.   For example, you can use the coding for general classification of the notification.
     */
    public codeGroup: string,
    /**
     * Key from the assigned catalog that is used to code the notification.   For example, you can use the coding to classify the notification according to the problem type.
     */
    public coding: string,
    /**
     * Short Text for Code (Up to 40 Characters in Length)   Text of up to 40 characters that describes the object in more detail. This description is also known as short text.
     */
    public codingText: string,
    /**
     * Key identifying the work center.
     */
    public workCenter: string,
    /**
     * Short description   Field in which you can describe the operating resource in more detail. For example, a work center or a production resource/tool.
     */
    public workCenterText: string,
    /**
     * Start of Malfunction (Time)   Time at which the malfunction started or at which the problem occurred
     */
    public startMalfunctionTime: string,
    /**
     * End of Malfunction (Time)   Time at which the malfunction ended, or at which the problem was solved
     */
    public endMalfunctionTime: string,
    /**
     * Breakdown Duration   Time entered to record the length of machine downtime   If you have entered from when to when the machine breakdown occurred, the system automatically calculates the entry in this field.
     */
    public breakdownDuration: number | string,
    /**
     * Unit for Breakdown Duration   Unit of time entered to record the length of machine downtime   If you prefer to make the entry using a different unit of time, you must overwrite the unit of time displayed with the new unit and press ENTER. The system then converts the downtime.   Length of downtime: 30   Einheit:            Minutes
     */
    public breakdownDurationUnit: string,
    /**
     * Location of maintenance object   The key in this field indicates a location within a plant.
     */
    public location: string,
    /**
     * User-definable text, 40 characters long.
     */
    public locationText: string,
    /**
     * In this field you can designate a specific room for the asset.   The field is used for informational purposes, and can be used as a sort criterion in reports (for example, the inventory list).
     */
    public room: string,
    /**
     * Object Long Text Available   This indicator informs you that there is a long text for the object, that is, for the item, task and so on.
     */
    public longTextExists: boolean,
    public longText: string,
    /**
     * Date on Which Record Was Created
     */
    public createdDate?: Date,
    /**
     * Date of Notification   Date at which the notification was created.
     */
    public notificationDate?: Date,
    /**
     * Start of Malfunction (Date)   Date of day on which the malfunction started, or on which the problem occurred.
     */
    public startMalfunctionDate?: Date,
    /**
     * End of Malfunction (Date)   Date of day on which the problem was solved, or on which the malfunction ended.
     */
    public endMalfunctionDate?: Date,
    public logs?: NotificationItem[]
  ) {}
}
